import React from "react";

// Reusable intersection grid: faint gold lines with nodes at crossings.
export const IntersectGrid = ({ className = "", cols = 4, rows = 3 }) => {
  const vLines = Array.from({ length: cols - 1 }, (_, i) => ((i + 1) / cols) * 100);
  const hLines = Array.from({ length: rows - 1 }, (_, i) => ((i + 1) / rows) * 100);
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      {vLines.map((l, i) => (
        <div key={`v${i}`} className="absolute top-0 bottom-0 w-px bg-primary-gold/10" style={{ left: `${l}%` }} />
      ))}
      {hLines.map((l, i) => (
        <div key={`h${i}`} className="absolute left-0 right-0 h-px bg-primary-gold/10" style={{ top: `${l}%` }} />
      ))}
      {vLines.map((vl, i) => hLines.map((hl, j) => (
        <span key={`n${i}-${j}`} className="absolute w-[3px] h-[3px] rounded-full bg-primary-gold/60 -translate-x-1/2 -translate-y-1/2" style={{ left: `${vl}%`, top: `${hl}%` }} />
      )))}
    </div>
  );
};

export const Backdrop = ({ src, opacity = 0.32 }) => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden>
    <img src={src} alt="" className="w-full h-full object-cover" style={{ opacity: Math.max(opacity, 0.3) }} />
    <div className="absolute inset-0 bg-gradient-to-b from-obsidian/85 via-obsidian/45 to-obsidian/90" />
  </div>
);

export const CornerTicks = () => (
  <>
    <span className="absolute top-0 left-0 w-3 h-px bg-primary-gold/50" />
    <span className="absolute top-0 left-0 w-px h-3 bg-primary-gold/50" />
    <span className="absolute bottom-0 right-0 w-3 h-px bg-primary-gold/50" />
    <span className="absolute bottom-0 right-0 w-px h-3 bg-primary-gold/50" />
  </>
);

export default IntersectGrid;
